// eslint-disable-next-line no-unused-vars
import React, { memo, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import SuccessCheckout from 'Containers/Checkout/SuccessCheckout';
import useRouter from 'Hooks/useRouter';
import useFetch from 'Hooks/useFetch';
import { API_ORDERS } from 'Constants';
import OrderModel from 'Containers/OrderModel';

const SuccessCheckoutPage = memo(() => {
  const { t } = useTranslation();
  const { location, replace } = useRouter();
  const { orders } = location?.state || {};
  const [ordersState, setOrders] = useState((orders || []).map(order => new OrderModel(order.order || {})));
  const [ordersProducts, setOrdersProducts] = useState({});
  const fetcher = useFetch();

  useEffect(() => {
    // remove order from state so next refresh will not contain the same order
    if (orders?.length) {
      replace(location.pathname);

      Promise.all(orders.map(order => fetcher(`${API_ORDERS}/${order.order.id}`, { noCancel: true })
        .then(data => {
          setOrders(prevState => prevState.map(o => {
            if (o.id === data.id) {
              return new OrderModel({
                ...(o?.getData() || {}),
                ...(data || {}),
                stockReservation: order?.order?.stockReservation,
              });
            }
            return o;
          }));
          setOrdersProducts(prevState => ({
            ...prevState,
            [data.id]: data.items,
          }));
        })
      ));
    }
  }, [location?.state]);

  useEffect(() => {
    // Go to checkout if no order
    if (!ordersState?.length) {
      replace('/checkout');
    }
  }, [ordersState?.id]);

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('common.pages.checkoutSuccess') }</title>
      </Helmet>
      { ordersState.map((order, index) => (
        <SuccessCheckout
          key={ order.id }
          products={ ordersProducts[order.id] }
          order={ order }
          isFirstOrder={ index === 0 }
          isLastOrder={ index === ordersState.length - 1 }
        />
      )) }
    </>
  );
});
SuccessCheckoutPage.displayName = 'SuccessCheckoutPage';

export default SuccessCheckoutPage;
